import _ from 'lodash';
import { gameConfig } from '../../../redux/config';
import {
    GET_INITIAL_METADATA,
    GET_CURRENT_METADATA,
    UPDATE_SORTED_LIST,
    UPDATE_CHART_LIST,
    UPDATE_MATCH_STATE,
    UPDATE_SELECTED_MATCH,
    UPDATE_BONUS,
    APPLY_BOOST,
    UPDATE_GAME_TAGS,
    UPDATE_CHART_STATE,
    UPDATE_PREDICT_AWARD,
    UPDATE_SELECTED_NOMINEE,
    RESET_DATA,
    GAME_PROGRESS,
    START_NEW_GAME
} from '../actions';

export default function fanpageReducer(state = {}, action) {
    let newState = { ...state };
    const { type, payload } = action;

    switch (type) {
        case GET_INITIAL_METADATA:
            newState = _.merge({}, { ...newState }, { ...payload });
            break;
        case GET_CURRENT_METADATA:
            newState = {
                ...newState,
                [payload.dataKey]: {
                    ...newState[payload.dataKey],
                    Data: { ...newState[payload.dataKey].Data, ...payload.data }
                }
            };
            break;
        case GAME_PROGRESS:
            newState = {
                ...newState,
                [payload.key]: payload.val
            };
            break;
        case START_NEW_GAME:
            newState = {
                ...newState,
                [payload.key]: {
                    ...newState[payload.key],
                    StartNewGame: payload.val,
                }
            };
            break;
        case UPDATE_GAME_TAGS:
            newState = {
                ...newState,
                [payload.key]: {
                    ...newState[payload.key],
                    ...payload.val,
                }
            };
            break;
        // Charts
        case UPDATE_SORTED_LIST:
            newState = {
                ...newState,
                Charts: {
                    ...newState.Charts,
                    Data: { ...newState.Charts.Data, Items: payload }
                }
            }
            break;
        case UPDATE_CHART_LIST:
            let chartIndex = _.findIndex(newState.Charts.Data.Items, payload.currItem);
            if (chartIndex === -1 && payload.rank) {
                newState.Charts.Data.Items.splice(payload.rank - 1, 0, { ...payload.currItem });
                newState.Charts.Data.Items = newState.Charts.Data.Items.map((val, i) => ({ ...val, Position: i + 1 }));
            } else {
                newState.Charts.Data.Items = newState.Charts.Data.Items.filter((_, i) => i !== chartIndex)
                    .map((val, i) => ({ ...val, Position: i + 1 }));
            }
            break;
        case UPDATE_CHART_STATE:
            newState = {
                ...newState,
                Charts: {
                    ...newState.Charts,
                    Data: {
                        ...newState.Charts.Data,
                        gameState: {
                            ...newState.Charts.Data.gameState,
                            ...payload
                        }
                    }
                }
            }
            break;

        // Music match
        case UPDATE_SELECTED_MATCH:
            let selectedAlbum = payload.AlbumItems.find((el) => {
                return el.IsSelected === true;
            });
            const matchedIndex = _.findIndex(newState.MusicMatch.Data.currPickedItems, { MatchupSettingId: payload.MatchupSettingId });

            newState = {
                ...newState,
                MusicMatch: {
                    ...newState.MusicMatch,
                    Data: {
                        ...newState.MusicMatch.Data,
                        Items: newState.MusicMatch.Data.Items.map(obj =>
                            obj.MatchupSettingId === payload.MatchupSettingId ? { ...payload } : { ...obj }
                        ),
                        currPickedItems: matchedIndex !== -1 ? newState.MusicMatch.Data.currPickedItems.map(el => {
                            if (payload.MatchupSettingId && (el.MatchupSettingId === payload.MatchupSettingId)) {
                                return { ...payload, AlbumItems: selectedAlbum }
                            }
                            return { ...el }
                        }) : [...newState.MusicMatch.Data.currPickedItems, { ...payload, AlbumItems: selectedAlbum }]
                    }
                }
            }
            break;
        case UPDATE_BONUS:
            newState.MusicMatch.Data.bonus.push({ ...payload });
            break;
        case UPDATE_MATCH_STATE:
            newState = {
                ...newState,
                MusicMatch: {
                    ...newState.MusicMatch,
                    Data: {
                        ...newState.MusicMatch.Data,
                        gameState: {
                            ...newState.MusicMatch.Data.gameState,
                            ...payload
                        }
                    }
                }
            }
            break;

        case APPLY_BOOST:
            newState = {
                ...newState,
                MusicMatch: {
                    ...newState.MusicMatch,
                    Data: {
                        ...newState.MusicMatch.Data,
                        Items: newState.MusicMatch.Data.Items.map(obj =>
                            obj.MatchupSettingId === payload.MatchupSettingId ? { ...obj, BoostType: obj.BoostType === 0 ? 1 : 0 } : { ...obj }
                        ),
                    }
                }
            }
            break;

        // Predict award
        case UPDATE_PREDICT_AWARD:
            newState = {
                ...newState,
                AwardShow: {
                    ...newState.AwardShow,
                    Data: {
                        ...newState.AwardShow.Data,
                        gameState: {
                            ...newState.AwardShow.Data.gameState,
                            ...payload
                        }
                    }
                }
            }
            break;
        case UPDATE_SELECTED_NOMINEE:
            const selectedNominee = payload.Nominees.find((el) => {
                return el.IsSelected === true;
            });
            const matchedIdx = _.findIndex(newState.AwardShow.Data.currPickedItems, { CategoryId: payload.CategoryId });

            newState = {
                ...newState,
                AwardShow: {
                    ...newState.AwardShow,
                    Data: {
                        ...newState.AwardShow.Data,
                        Categories: newState.AwardShow.Data.Categories.map(obj =>
                            obj.CategoryId === payload.CategoryId ? { ...payload } : { ...obj }
                        ),
                        currPickedItems: matchedIdx !== -1 ? newState.AwardShow.Data.currPickedItems.map(el => {
                            if (payload.CategoryId && (el.CategoryId === payload.CategoryId)) {
                                return { ...payload, Nominees: selectedNominee }
                            }
                            return { ...el }
                        }) : [...newState.AwardShow.Data.currPickedItems, { ...payload, Nominees: selectedNominee }]
                    }
                }
            }
            break;

        // reset common
        case RESET_DATA:
            newState = {
                ...newState,
                [payload.dataKey]: {
                    ...newState[payload.dataKey],
                    Data: {
                        ...gameConfig[payload.dataKey].Data
                    }
                }
            }
            break;
        default:
            break;
    }
    return newState;
}